import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      // 首页
      path:'/home',name:'Index',
      component:resolve => require(['@/views/index'],resolve),
      children:[
        // 首页
        {
          path:'/home',name:'Home',
          component:resolve => require(['@/views/home'],resolve)
        },
        {
          // 企业文化
          path:'/culture',name:'Culture',
          component:resolve => require(['@/views/culture'],resolve)
        },
        {
          // 智能云平台
          path:'/smart',name:'Smart',
          component:resolve => require(['@/views/smart'],resolve)
        },
        {
          // 解决方案
          path:'/scheme',name:'Scheme',
          component:resolve => require(['@/views/scheme'],resolve)
        },
        {
          // 产品中心
          path:'/product',name:'Product',
          component:resolve => require(['@/views/product'],resolve)
        },
        {
          // 新闻中心
          path:'/news',name:'News',
          component:resolve => require(['@/views/news'],resolve),
        },
        {
          // 新闻详情
          path:'/news/detail',name:'Detail',
          component:resolve => require(['@/views/detail'],resolve)
        },
        {
          // 加盟合作
          path:'/league',name:'League',
          component:resolve => require(['@/views/league'],resolve)
        }
      ]
    },
    {
      path: '**',
      redirect: '/home'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js